import { Box, Typography } from "@mui/material";
import partnaire from "../images/partnaire.png";
import Keolis from "../images/Keolis.png";
import Effia from "../images/Effia.png";
import AlfaPark from "../images/alfaPark.jpg";
import patnaire from "../images/patnaire.png";
import { useTranslation } from "react-i18next";
function ViviaPatners() {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        background: ` url(${partnaire})`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        width: "100%",
        height: "auto",
        pt: 2,
        pb: 3,
        gap: 3,
      }}
    >
      <Typography
        sx={{
          fontFamily: "Roboto",
          fontWeight: 500,
          fontSize: { xs: "14px", md: "18px" },
          lineHeight: { xs: "25px", lg: "77px" },
          letterSpacing: "3%",
          textAlign: "center",
          verticalAlign: "middle",
          maxWidth: { xs: "50%", lg: "100%" },
          color: " #221D55",
        }}
      >
        {t("Partnering with Europe’s most forward-thinking mobility providers")}
      </Typography>
      <Box display="flex" alignItems="center" justifyContent="center" gap={8}>
        <Box
          component="img"
          src={Keolis}
          alt="Keolis"
          sx={{
            height: "auto",
            width: {
              xs: "20%", // mobile

              md: "10%", // tablette
            },
          }}
        />
        <Box
          component="img"
          src={Effia}
          alt="Effia"
          sx={{
            height: "auto",
            width: {
              xs: "20%", // mobile

              md: "10%", // tablette
            },
          }}
        />

        <Box
          component="img"
          src={AlfaPark}
          alt="AlfaPark"
          sx={{
            height: "auto",
            width: {
              xs: "20%", // mobile

              md: "10%", // tablette
            },
          }}
        />

        <Box
          component="img"
          src={patnaire}
          alt="patnaire"
          sx={{
            height: "auto",
            width: {
              xs: "20%", // mobile

              md: "10%", // tablette
            },
          }}
        />
      </Box>
    </Box>
  );
}

export default ViviaPatners;
